import React, { useState } from "react";
import Icon from "../../../components/AppIcon";

const FAQSection = ({ faqs = [] }) => {
  const [openIndex, setOpenIndex] = useState(-1);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  if (!faqs.length) {
    return (
      <p className="text-center text-muted-foreground">
        No FAQs available
      </p>
    );
  }

  return (
    <div className="space-y-3 md:space-y-4">
      {faqs.map((faq, index) => (
        <div
          key={faq._id}
          className="bg-card rounded-lg border border-border shadow-sm overflow-hidden transition-base hover:shadow-md"
        >
          <button
            onClick={() => toggleFAQ(index)}
            className="w-full p-4 md:p-6 flex items-center justify-between text-left focus-ring"
            aria-expanded={openIndex === index}
          >
            <h4 className="text-base md:text-lg font-heading font-bold text-foreground pr-4">
              {faq.question}
            </h4>
            <Icon
              name={openIndex === index ? "ChevronUp" : "ChevronDown"}
              size={24}
              color="var(--color-primary)"
              className="flex-shrink-0"
            />
          </button>

          {openIndex === index && (
            <div className="px-4 md:px-6 pb-4 md:pb-6">
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {faq.answer}
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQSection;
